import _taggedTemplateLiteral from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\tposition: ", ";\n\tvertical-align: ", ";\n\n\t/**\n\t * The baselines of the VW Fonts are too low and appear broken. In certain cases,\n\t * letters like \"y\", \"g\" or \"q\" are cut at the bottom. To fix this issue,\n\t * we add a margin to the bottom that is relative to the current font-size\n\t * while removing it at the same time from the top. This is to fix the baseline\n\t * of the VW Fonts and to make them behave more like Helvetica or Arial.\n\t * Should the font change in the future, we'll need to adjust the values accordingly\n\t * or remove them completely by resetting them to the original value \"margin: 0\".\n\t *\n\t * PLEASE DO NOT CHANGE OR REMOVE THESE VALUES UNLESS YOU KNOW EXACTLY WHAT YOU ARE DOING!\n\t */\n\tmargin: -0.11em 0 0.11em 0;\n\tfont-family: ", ";\n\tcolor: ", ";\n\tword-break: ", ";\n\tfont-weight: ", ";\n\tfont-size: ", ";\n\tline-height: ", ";\n\tletter-spacing: ", ";\n\t", ";\n\ttext-decoration: ", ";\n\twhite-space: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import { warn } from '../helpers/logger';
import { styled } from '../theme-provider';
import { createAlignmentStyles } from './helpers';
export var TextAppearance;

(function (TextAppearance) {
  // These textAppearances should be used in combination with the old breakpoints.
  TextAppearance["headline600"] = "headline600";
  TextAppearance["headline550"] = "headline550";
  TextAppearance["headline500"] = "headline500";
  TextAppearance["headline450"] = "headline450";
  TextAppearance["headline400"] = "headline400";
  TextAppearance["headline350"] = "headline350";
  TextAppearance["headline300"] = "headline300";
  TextAppearance["headline250"] = "headline250";
  TextAppearance["headline200"] = "headline200";
  TextAppearance["label300"] = "label300";
  TextAppearance["label250"] = "label250";
  TextAppearance["label200"] = "label200";
  TextAppearance["label150"] = "label150";
  TextAppearance["label100"] = "label100";
  TextAppearance["copy300"] = "copy300";
  TextAppearance["copy250"] = "copy250";
  TextAppearance["copy200"] = "copy200";
  TextAppearance["copy150"] = "copy150";
  TextAppearance["copy100"] = "copy100"; // These textAppearances should be used in combination with the new breakpoints.

  TextAppearance["headline0600"] = "headline600";
  TextAppearance["headline0550"] = "headline550";
  TextAppearance["headline0500"] = "headline500";
  TextAppearance["headline0450"] = "headline450";
  TextAppearance["headline0400"] = "headline400";
  TextAppearance["headline0350"] = "headline350";
  TextAppearance["headline0300"] = "headline300";
  TextAppearance["headline0250"] = "headline250";
  TextAppearance["headline0200"] = "headline200";
  TextAppearance["label0300"] = "label300";
  TextAppearance["label0250"] = "label250";
  TextAppearance["label0200"] = "label200";
  TextAppearance["label0150"] = "label150";
  TextAppearance["label0100"] = "label100";
  TextAppearance["copy0300"] = "copy300";
  TextAppearance["copy0250"] = "copy250";
  TextAppearance["copy0200"] = "copy200";
  TextAppearance["copy0150"] = "copy150";
  TextAppearance["copy0100"] = "copy100";
})(TextAppearance || (TextAppearance = {}));

export var TextTag;

(function (TextTag) {
  TextTag["span"] = "span";
  TextTag["div"] = "div";
  TextTag["p"] = "p";
  TextTag["h1"] = "h1";
  TextTag["h2"] = "h2";
  TextTag["h3"] = "h3";
  TextTag["h4"] = "h4";
  TextTag["h5"] = "h5";
  TextTag["sub"] = "sub";
  TextTag["sup"] = "sup";
  TextTag["strong"] = "strong";
  TextTag["del"] = "del";
})(TextTag || (TextTag = {}));

export var TextAlignment;

(function (TextAlignment) {
  TextAlignment["center"] = "center";
  TextAlignment["left"] = "left";
  TextAlignment["right"] = "right";
})(TextAlignment || (TextAlignment = {}));

export var TextColor;

(function (TextColor) {
  TextColor["primary"] = "primary";
  TextColor["secondary"] = "secondary";
  TextColor["inherit"] = "inherit";
})(TextColor || (TextColor = {}));

export var WhiteSpace;

(function (WhiteSpace) {
  WhiteSpace["normal"] = "normal";
  WhiteSpace["nowrap"] = "nowrap";
  WhiteSpace["pre"] = "pre";
  WhiteSpace["preLine"] = "pre-line";
  WhiteSpace["preWrap"] = "pre-wrap";
  WhiteSpace["initial"] = "initial";
  WhiteSpace["inherit"] = "inherit";
})(WhiteSpace || (WhiteSpace = {}));

var BaseComponent = function BaseComponent(props) {
  var _props$tag = props.tag,
      tag = _props$tag === void 0 ? TextTag.div : _props$tag,
      children = props.children,
      className = props.className;
  var Component = TextTag[tag];
  return React.createElement(Component, {
    className: className
  }, children);
};

BaseComponent.displayName = 'BaseComponent';
var headAppearanceList = [TextAppearance.headline600, TextAppearance.headline550, TextAppearance.headline500, TextAppearance.headline450, TextAppearance.headline400, TextAppearance.headline350, TextAppearance.headline300, TextAppearance.headline250, TextAppearance.headline200, TextAppearance.headline0600, TextAppearance.headline0550, TextAppearance.headline0500, TextAppearance.headline0450, TextAppearance.headline0400, TextAppearance.headline0350, TextAppearance.headline0300, TextAppearance.headline0250, TextAppearance.headline0200];

function getTextDecoration(props) {
  if (typeof props.strikethrough === 'boolean') {
    return props.strikethrough ? 'line-through' : 'initial';
  }

  return;
}

var StyledTextComponent = styled(BaseComponent).withConfig({
  displayName: "StyledTextComponent",
  componentId: "sc-hqqa9q"
})(_templateObject(), function (props) {
  return (props.sub || props.sup) && 'static';
}, function (props) {
  if (props.sup) {
    return 'super';
  }

  if (props.sub) {
    return 'sub';
  }

  return '';
}, function (props) {
  var appearance = props.appearance,
      theme = props.theme;

  if (!appearance) {
    return;
  }

  var textKey = theme.textAppearances[appearance];
  return textKey.fontFamily;
}, function (props) {
  return props.color === TextColor.inherit ? 'inherit' : props.color === TextColor.secondary ? props.theme.text.color.secondary : props.theme.text.color.primary;
}, function (props) {
  return props.wordBreak && 'break-word' || 'inherit';
}, function (props) {
  return props.bold ? props.theme.text.weight.bold : props.appearance && headAppearanceList.indexOf(props.appearance) > -1 ? props.theme.text.weight.light : props.theme.text.weight.regular;
}, function (props) {
  var appearance = props.appearance,
      staticSize = props.staticSize,
      sub = props.sub,
      sup = props.sup,
      theme = props.theme;

  if (!appearance) {
    return;
  }

  var fontKey = sub || sup ? 'reducedFontSize' : 'fontSize';
  var textKey = theme.textAppearances[appearance];
  return staticSize ? textKey.static[fontKey] : textKey[fontKey];
}, function (props) {
  var appearance = props.appearance,
      staticSize = props.staticSize,
      sub = props.sub,
      sup = props.sup,
      theme = props.theme;

  if (sub || sup) {
    return '0';
  }

  if (!appearance) {
    return;
  }

  var textKey = theme.textAppearances[appearance];
  return staticSize ? textKey.static.lineHeight : textKey.lineHeight;
}, function (props) {
  var appearance = props.appearance,
      staticSize = props.staticSize,
      theme = props.theme;

  if (!appearance) {
    return;
  }

  var textKey = theme.textAppearances[appearance];
  var letterSpacingKey = staticSize ? textKey.static.letterSpacing : textKey.letterSpacing;
  return letterSpacingKey;
}, function (props) {
  return createAlignmentStyles(props);
}, getTextDecoration, function (props) {
  return props.whiteSpace;
});
StyledTextComponent.displayName = 'StyledTextComponent';
export var TextContext = React.createContext({});
export function Text(props) {
  var appearance = props.appearance,
      bold = props.bold,
      children = props.children,
      strikethrough = props.strikethrough,
      sub = props.sub,
      sup = props.sup,
      tag = props.tag,
      textAlign = props.textAlign,
      wordBreak = props.wordBreak,
      whiteSpace = props.whiteSpace,
      color = props.color,
      staticSize = props.staticSize;

  if (appearance && appearance.match(/textTypes/)) {
    warn('`textTypes` are deprecated, because they use the old breakpoints. Use `textAppearances` instead.');
  }

  return React.createElement(TextContext.Consumer, null, function (context) {
    var textColor = color || context.textColor;
    var textAppearance = appearance || context.textAppearance || TextAppearance.copy0200;
    var textWeight = context.bold;

    if (typeof bold === 'boolean') {
      textWeight = bold;
    }

    var textTag = tag || sub && TextTag.sub || sup && TextTag.sup || context.textAppearance && TextTag.span;
    return React.createElement(StyledTextComponent, {
      appearance: textAppearance,
      bold: textWeight,
      sub: sub,
      sup: sup,
      tag: textTag,
      textAlign: textAlign,
      wordBreak: wordBreak,
      whiteSpace: whiteSpace,
      color: textColor,
      staticSize: staticSize,
      strikethrough: strikethrough
    }, React.createElement(TextContext.Provider, {
      value: {
        textAppearance: textAppearance,
        bold: bold,
        textColor: textColor
      }
    }, children));
  });
}